"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityLinkedItemsGrid = exports.EntityLinkedItemsGridDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var grid_1 = require("../elements/grid");
exports.EntityLinkedItemsGridDefaultProps = {
  spacing: 4,
  columns: 3
};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-left: -2px;\n    box-sizing: border-box;\n    opacity: 0.8;\n    padding: ", " 0 ", " ", "; \n    border: 1px dotted ", ";\n    background: #FAFAFA;\n    position: relative;\n    z-index: 10;\n  "], ["\n    margin-bottom: ", ";\n    margin-left: -2px;\n    box-sizing: border-box;\n    opacity: 0.8;\n    padding: ", " 0 ", " ", "; \n    border: 1px dotted ", ";\n    background: #FAFAFA;\n    position: relative;\n    z-index: 10;\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(3), theme_1.theme.UNIT(0), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-mid'))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(grid_1.Grid)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var EntityLinkedItemsGrid = function (props) {
  var className = props.className,
    items = props.items,
    rest = __rest(props, ["className", "items"]);
  return react_1.default.createElement(My.Container, __assign({
    items: items,
    className: className
  }, rest));
};
exports.EntityLinkedItemsGrid = EntityLinkedItemsGrid;
exports.EntityLinkedItemsGrid.defaultProps = exports.EntityLinkedItemsGridDefaultProps;
var templateObject_1, templateObject_2;